<template>
  <user-manager
    v-bind:canEdit="false"
    v-bind:context="'resident'"
    v-bind:showAssignedResidents="true"
    v-bind:functionalRoles="functionalRoles"
    v-bind:toolbarColor="appColor_ResidentLight"
    v-bind:toolbarColorDark="appColor_Resident"
  />
</template>

<script>
import UserManager from '@/components/UserManager'
import { AppColor } from '@/config.js'

export default {
  name: "AbbyResidentFacilitators",
  components: {
    UserManager
  },
  data() {
    return {
      appColor_ResidentLight: AppColor.ResidentLight,
      appColor_Resident: AppColor.Resident
    }
  },
  computed: {
    functionalRoles () {
      return [this.getExpression('FunctionalRole', 'FamilyFacilitator')]
    }
  }
}
</script>